import jwt_decode from "jwt-decode";

export const useAuth = (token) => {
	const decoded = token != null ? jwt_decode(token) : {};
	var current_time = new Date().getTime() / 1000;
	const expired = current_time > decoded.exp;

	return token && expired === false;
};